module.exports = __webpack_public_path__ + "media/base/customer_company_big-b91a2760.svg";